import { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import classBind from 'classnames/bind';
import logoY from 'resources/img/logo-y-black.svg';
import logoGM from 'resources/img/logo-gm.png';
import logoVW from 'resources/img/logo-vw.png';
import logoNissan from 'resources/img/logo-nissan.png';

import styles from './styles.scss';

let cx = classBind.bind(styles);

class Logo extends Component {
  render() {
    var brand = this.props.brand;

    let className = cx({
      logo: true,
    });

    return (
      <div className={classnames(className)}>
        {brand === 'vw' && <img src={logoVW} alt="Volkswagen" />}
        {brand === 'gm' && <img src={logoGM} alt="Chevrolet" />}
        {brand === 'nissan' && <img src={logoNissan} alt="Nissan" />}
        {!brand && <img src={logoY} alt="Territorio Yacopini" />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    brand: state.configuration.brand,
  };
};

export default connect(mapStateToProps)(Logo);
